"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var enums_1 = require("../enums");

var utils_1 = require("../utils");

exports.evaluateStringVariable = function (stringVariable, variableDictionary) {
  switch (stringVariable.type) {
    case enums_1.StringVariableType.Constant:
      {
        return stringVariable.value;
      }

    case enums_1.StringVariableType.Map:
      {
        var variable = variableDictionary[stringVariable.key];

        if (utils_1.hasValue(variable) && variable.type === enums_1.VariableValueType.String) {
          return variable.value;
        } else {
          return utils_1.withDefault(stringVariable.defaultValue, "");
        }
      }

    case enums_1.StringVariableType.Add:
      {
        return stringVariable.variables.map(function (x) {
          return exports.evaluateStringVariable(x, variableDictionary);
        }).join();
      }
  }
};